import { forwardRef, } from "react";
import { CompanyLogo } from "../../../assets/Order";
import TabelSummary from "../../comman/tableEstimationSummery";
import capitalizeFirstLetter from "../../comman/capitalizeFirstLetter"
import axios from "axios";
import { useEffect, useState } from "react";
const Base_Url = process.env.REACT_APP_BASE_URL;

const ServiceInvoice = forwardRef(({ service }, ref) => {
  
  const [additionalCharges,setAdditionalCharges]=useState(null);

  useEffect(() => {
    const fetchExistingInvoice = async () => {
      try {
        const token = localStorage.getItem("token");
        const response = await axios.get(
          `${Base_Url}/api/serviceProcess/getAdditionalCharges/${service?.bookedServiceId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (response.data?.success && response.data?.data?.length > 0) {
          const data = response.data.data[0];          
          setAdditionalCharges(data); 
        }
      } catch (err) {
        console.warn("No invoice found or fetch failed:", err.message);
      }
    };

    if (service?.bookedServiceId) fetchExistingInvoice();
  }, [service?.bookedServiceId]);

  const totalAdditional = additionalCharges?.additionalCharges?.reduce(
  (sum, item) => sum + Number(item.chargeAmount || 0),
  0
) || 0;

  if (!service) {
    return (
      <div className="bg-white border border-red-600 rounded-xl shadow-md p-6 max-w-3xl mx-auto">
        <h2 className="text-xl font-bold mb-4 text-[#A63F40]">
          Estimation Summary
        </h2>
        <p className="text-gray-600">No Invoice data available yet.</p>
      </div>
    );
  }
console.log("Service data",service);

  return (
    <div className="max-w-5xl mx-auto bg-[#fcfcfc]" ref={ref}>
      <div className="p-4 relative">

        <div className="grid grid-cols-2 pb-5 border-b-2 border-gray-500">
          <div className="flex flex-col justify-between">
            <img src={CompanyLogo} className="w-[70%] h-[38%]" alt="Logo" />
            <p className="text-4xl font-semibold">Invoice</p>
          </div>
          <div className="flex flex-col space-y-1 justify-start items-end">
            <p className="text-xl font-medium text-left">Asia Link Computers</p>
            <p>Shop No.-11, 1577,</p>
            <p>BhagyaNagari Society,</p>
            <p>Tilak Road, Sadashiv Peth,</p>
            <p>Pune - 411030</p>
            <p>(Near Baba Computer, Opposite Maharashtra Mandal)</p>
          </div>
        </div>

        <div className="mt-3 flex flex-row space-x-6 justify-between items-start">
          <div className="flex flex-col space-y-1">
          <p>
            Person Name : <span>{capitalizeFirstLetter(service.user?.name || "-")}</span>
          </p>
          <p>
            Contact No : {service.user?.mobileNumber || "-"}
          </p>
          <p className="w-[450px]">
            Address : {service.address
                  ? `${service.address.buildingBlock.toUpperCase()} - ${service.address.flatNo}, ${service.address.buildingName}, ${service.address.landmark || ""}, ${service.address.streetName || ""}, ${service.address.city}, ${service.address.state}, ${service.address.pincode}`
                  : "-"}
          </p>
          </div>
          <div className="">
            <p>
              Date:{" "}
              <span>
                {additionalCharges?.invoiceDate
                  ? new Date(additionalCharges.invoiceDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  })
                  : "-"
                }
              </span>
            </p>
          </div>
        </div>

        <div className="overflow-x-auto my-4">
          <TabelSummary
            submittedData={service?.items || []}
          />
        </div>

        <div className="mt-5">
          <h3 className="font-semibold mb-2">Additional Charges</h3>
            {additionalCharges?.additionalCharges?.length > 0 ? (
            <table className="w-full border text-center">
              <thead className="bg-[#a63f40] text-white border border-black">
              <tr>
                <th className="p-2">No</th>
                <th className="p-2">Name</th>
                <th className="p-2">Amount</th>
              </tr>
              </thead>
              <tbody>
              {additionalCharges.additionalCharges.map((ch, idx) => (
              <tr key={idx} className="bg-white">
                <td className="border-b border-l border-black p-2">{idx + 1}</td>
                <td className="border-b border-black p-2">{ch.chargeName}</td>
                <td className="border-b border-r border-black p-2">₹ {Math.round(ch.chargeAmount)}</td>
              </tr>
              ))}
            </tbody>
            </table>
            ) : (
            <div className="text-sm text-gray-600">No Additional Charges</div>
            )}
        </div>

        <div className="ml-auto flex justify-between border border-gray-700 rounded-lg mb-6 mt-6 bg-white px-3 py-1 w-1/2 ">
            <div className="flex flex-col space-y-1 font-semibold w-2/3">
              <p className=""> Service Cost :</p>
              <p className=""> Discount :</p>
              <p className="">Sub Total :</p>
              <p className="">Additional Service Cost :</p>
              <p className="">Final Cost :</p>
            </div>
            <div className="flex flex-col space-y-1 font-medium w-1/3">
              <p className="">₹{Math.round(service.totalCost)}</p>
              <p className="">{Math.round(service.discountPercent)}%</p>
              <p className="">₹{Math.round(service.totalCost - (service.discountPercent / 100) * (service.totalCost))}</p>          
              <p className="">+ ₹{totalAdditional}</p>
              <p className="font-semibold">₹{Math.round(service.finalCost)}</p>
            </div>
        </div>


       <div
          className="text-xs text-gray-500 italic hidden print:block fixed bottom-0 left-0 w-full 
            border-t border-gray-300 text-center bg-white py-1 "
        >
          System generated invoice — Date: {additionalCharges?.invoiceDate
                  ? new Date(additionalCharges.invoiceDate).toLocaleDateString("en-GB", {
                  day: "2-digit",
                  month: "short",
                  year: "numeric",
                  })
                  : "-"
                }

        </div>
      </div>
    </div>
  );
});

export default ServiceInvoice;
